import { isReadMessageEnabled } from '@/feature/message.feature';
import { selectMessages } from '@repo/api-adapters/selectors/order-messages.selectors';
import { useOrderMessages } from '@repo/hooks';
import type { MessageTab } from '@repo/types/messages-tabs';

import { useAsset, useAssetParams } from '@/hooks/asset.hooks';

export const useMessages = (activeTab: MessageTab | undefined) => {
    const { assetId, assetType } = useAssetParams();
    const enabled = activeTab ? isReadMessageEnabled(assetType, activeTab) : false;

    const {
        data: assetData,
        isLoading: isAssetLoading,
        isError: isAssetError,
        error: assetError,
    } = useAsset(assetType, assetId);

    const {
        data: orderMessages,
        isError: isOrderMessagesError,
        error: orderMessagesError,
        isLoading: isOrderMessagesLoading,
    } = useOrderMessages({ assetId, sortByDateTime: true }, enabled);

    const messages = selectMessages(assetData, orderMessages);

    const tabMessages = messages.filter((message) => {
        return message.messageType === activeTab;
    });

    return {
        messages: tabMessages,
        isLoading: isAssetLoading || isOrderMessagesLoading,
        isError: isAssetError || isOrderMessagesError,
        error: assetError ?? orderMessagesError,
    };
};
